import {FC} from 'react'
import {Tab, TabList, TabPanel, Tabs} from 'react-tabs'
import {TabModel} from '../../../../../models'
import {useHoteleria} from '../../../../../hooks/useHoteleria'
import IconButton from '../../../../../components/UI/Button/IconButton'
import {FormTerms} from '../components/forms/FormTerms'

const DetailTyCPanel: FC = () => {
  const {currentTabItem, changeCurrentTabItem} = useHoteleria()
  const handleBack = () => {
    const obj: TabModel = {
      ...currentTabItem,
      showPanel: false,
    }
    changeCurrentTabItem(obj)
  }
  let isDisabled = currentTabItem.idToEdit ? true : false
  return (
    <>
      <div className='sdx_content_tab_panel'>
        {isDisabled && <IconButton onClick={handleBack} color='#283897' />}
        <Tabs className={'sdx_sub_react_tab_panel '}>
          <TabList className={'sdx_sub_tab_panel p-0'}>
            <Tab className={'sdx_sub_tab_panel_option'}>Actualizar TyC</Tab>
          </TabList>
          <TabPanel>
            <FormTerms />
          </TabPanel>
        </Tabs>
      </div>
    </>
  )
}

export {DetailTyCPanel}
